import {GET_FORM, SEND_FORM} from "./action_types";
import {getApi, postApi} from "../../data/ApiService";
import {SET_EMPLOYMENT_FORM, SET_LOADING} from "./mutation_types";


export default {
    async [GET_FORM]({commit},payload){
      try {
          commit(SET_LOADING,true);
          const response = await getApi(`topics/${payload.id}/fields`);
          commit(SET_EMPLOYMENT_FORM,response.data);
      }catch (e) {
          console.log(e);
      }
      finally {
          commit(SET_LOADING,false);
      }
    },
    async [SEND_FORM]({commit},payload){
        try {
            const response = await postApi(`topics/${payload.id}/fields`,payload);
            console.log(response);
            return true;
        }catch (e) {
            console.log(e);
            return false;
        }

    }
}